import { render, staticRenderFns } from "./TableUsuarios.vue?vue&type=template&id=c816ab52&scoped=true"
import script from "./TableUsuarios.vue?vue&type=script&lang=js"
export * from "./TableUsuarios.vue?vue&type=script&lang=js"
import style0 from "./TableUsuarios.vue?vue&type=style&index=0&id=c816ab52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c816ab52",
  null
  
)

export default component.exports